/**
 * Login form modal
 */

jQuery(document).ready(function($) {

    if ( typeof vous_l10n === 'undefined' ) { // Ensure l10n is set
        return;
    }

    var modal = $('[data-remodal-id=custom-vitamins-login]').remodal({
        hashTracking: false,
        closeOnOutsideClick: false,
        closeOnEscape: false
    });

    $('.js-custom-vitamins-login-link').click(function(e) {
        e.preventDefault();
        modal.open();
    });
    
});
